import { Box, MenuItem, Select, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { useTable, usePagination, useFilters } from "react-table";
import styled from "styled-components";
import { SelectColumnFilter } from "./SelectColumnFilter";
import { Table } from "react-bootstrap";
import "./LogTable.css";
// import "../../css/tableComponentCss.css";

const LogTable = ({ logsData }) => {
  const Styles = styled.div`
    table {
      border-spacing: 0;
      border: 1px solid black;

      tr {
        :last-child {
          td {
            border-bottom: 0;
          }
        }
      }

      tbody {
        // max-height: 50vh;
      }

      th {
       position: sticky,
       top: 0
      }

      th,
      td {
        margin: 0;
        padding: 0.5rem;
        border-bottom: 1px solid black;
        border-right: 1px solid black;
        text-align: center;

        :last-child {
          border-right: 0;
        }
      }
    }
  `;

  // const activityTypeOptions = useMemo(() => {
  //   const data = formatTableData();
  //   const validData = data?.length
  //     ? data.filter((each) => each.activityType !== "")
  //     : [];
  //   const types = new Set(validData.map((row) => row?.activityType));
  //   console.log("typessd", [...types]);
  //   return [...types];
  // }, [logsData]);

  const columns = useMemo(
    () => [
      {
        Header: "IP Address",
        accessor: "ip",
        Cell: ({ value }) => {
          return (
            <div
              style={{
                // width: "120px",
                wordWrap: "break-word",
                // fontSize: "16px",
              }}
            >
              {value}
            </div>
          );
        },
      },
      {
        Header: "Activity Type",
        accessor: "activityType",
        Filter: SelectColumnFilter,
        filter: "equals",
        canFilter: true,

        Cell: ({ value }) => {
          return (
            <div
              style={{
                // width: "120px",
                wordWrap: "break-word",
                // fontSize: "16px",
              }}
            >
              {value}
            </div>
          );
        },
      },
      {
        Header: "Activity Details",
        columns: [
          {
            Header: "Section",
            accessor: "activityDetails.section",
            Cell: ({ value }) => {
              return (
                <div
                  style={{
                    // width: "120px",
                    wordWrap: "break-word",
                    // fontSize: "16px",
                  }}
                >
                  {value}
                </div>
              );
            },
          },
          {
            Header: "Package Name",
            accessor: "activityDetails.packageName",
            Cell: ({ value }) => {
              return (
                <div
                  style={{
                    // width: "120px",
                    wordWrap: "break-word",
                    // fontSize: "16px",
                  }}
                >
                  {value}
                </div>
              );
            },
          },
          {
            Header: "Profile Name",
            accessor: "activityDetails.profileName",
            Cell: ({ value }) => {
              return (
                <div
                  style={{
                    // width: "120px",
                    wordWrap: "break-word",
                    // fontSize: "16px",
                  }}
                >
                  {value}
                </div>
              );
            },
          },
          {
            Header: "Parameter Name",
            accessor: "activityDetails.parameterName",
            Cell: ({ value }) => {
              return (
                <div
                  style={{
                    // width: "120px",
                    wordWrap: "break-word",
                    // fontSize: "16px",
                  }}
                >
                  {value}
                </div>
              );
            },
          },
          {
            Header: "From Date",
            accessor: "activityDetails.fromEpoch",
            Cell: ({ value }) => {
              return (
                <div
                  style={{
                    // width: "120px",
                    wordWrap: "break-word",
                    // fontSize: "16px",
                  }}
                >
                  {value}
                </div>
              );
            },
          },
          {
            Header: "To Date",
            accessor: "activityDetails.toEpoch",
            Cell: ({ value }) => {
              return (
                <div
                  style={{
                    // width: "120px",
                    wordWrap: "break-word",
                    // fontSize: "16px",
                  }}
                >
                  {value}
                </div>
              );
            },
          },
        ],
      },

      {
        Header: "Last Updated",
        accessor: "createdAt",
        Cell: ({ value }) => {
          return (
            <div
              style={{
                // width: "120px",
                wordWrap: "break-word",
                // fontSize: "16px",
              }}
            >
              {value}
            </div>
          );
        },
      },
    ],
    [SelectColumnFilter]
  );

  function getFormattedDate(epoch, showTime = false) {
    if (!epoch) {
      return "";
    }
    const date = new Date(epoch);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    if (showTime) {
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    }
    return `${day}-${month}-${year}`;
  }

  function formatTableData() {
    let formattedData = [];
    console.log("logsData", logsData);
    if (logsData?.length) {
      formattedData = logsData.map((each) => ({
        ip: each?.deviceInfo?.ip || "",
        activityType: each?.activityType || "",
        activityDetails: {
          section: each?.metadata?.section || "",
          packageName: each?.metadata?.packageName || "",
          profileName: each?.metadata?.profileName || "",
          parameterName: each?.metadata?.parameterName || "",
          fromEpoch: getFormattedDate(each?.metadata?.fromEpoch),
          toEpoch: getFormattedDate(each?.metadata?.toEpoch),
        },
        createdAt: each?.createdAt
          ? getFormattedDate(each.createdAt, true)
          : "",
      }));
    }
    return formattedData;
  }

  const tableData = useMemo(() => formatTableData(), [logsData]);
  console.log("tableData", tableData);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data: tableData,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useFilters,
    usePagination
  );

  //   const defaultData = formatTableData();

  return (
    <Box mt={2} flexGrow={1}>
      {!logsData.length ? (
        <Typography variant="body5">No Data Found</Typography>
      ) : (
        <Box>
          <Table
            {...getTableProps()}
            responsive
            bordered
            className="custom-table"
          >
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()}>
                      {column.render("Header")}
                      <div>{column.Filter && column.render("Filter")}</div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row, i) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </Table>

          <div className="pagination mt-4 d-flex align-items-center gap-2">
            <div>
              <button
                onClick={() => gotoPage(0)}
                disabled={!canPreviousPage}
                className="btn btn-sm btn-outline-dark mx-1"
              >
                {"<<"}
              </button>{" "}
              <button
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
                className="btn btn-sm btn-outline-dark mx-1"
              >
                {"<"}
              </button>{" "}
              <button
                onClick={() => nextPage()}
                disabled={!canNextPage}
                className="btn btn-sm btn-outline-dark mx-1"
              >
                {">"}
              </button>{" "}
              <button
                onClick={() => gotoPage(pageCount - 1)}
                disabled={!canNextPage}
                className="btn btn-sm btn-outline-dark mx-1"
              >
                {">>"}
              </button>{" "}
            </div>
            <span>
              Page{" "}
              <strong>
                {pageIndex + 1} of {pageOptions.length}
              </strong>{" "}
            </span>
            <span>
              | Go to page:{" "}
              <input
                type="number"
                defaultValue={pageIndex + 1}
                onChange={(e) => {
                  const page = e.target.value ? Number(e.target.value) - 1 : 0;
                  gotoPage(page);
                }}
                style={{ width: "100px" }}
              />
            </span>{" "}
            <Select
              size="small"
              label=""
              value={pageSize}
              onChange={(e) => {
                setPageSize(Number(e.target.value));
              }}
            >
              {[10, 20, 30, 40, 50].map((pageSize) => (
                <MenuItem key={pageSize} value={pageSize}>
                  Show {pageSize}
                </MenuItem>
              ))}
            </Select>
          </div>
        </Box>
      )}
    </Box>
  );
};

export default LogTable;
